import { useContext } from 'react';

import { AddressFormContext } from './AddressFormContext';

export const useAddressFormContext = () => {
  const context = useContext(AddressFormContext);
  if (!context) {
    throw new Error(
      'useAddressFormContext must be used within an AddressFormContextProvider',
    );
  }
  return context;
};
